export default (ref, { root = document } = {}) => {
  const accordionButtons = document.querySelectorAll(
    '[id^="accordion-title-"]',
  );

  accordionButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const contentId = this.getAttribute("aria-controls");
      const content = document.getElementById(contentId);
      const expanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", !expanded);
      content.classList.toggle("grid-rows-[1fr]", !expanded);
      content.classList.toggle("grid-rows-[0fr]", expanded);
      content.classList.toggle("opacity-100", !expanded);
      content.classList.toggle("opacity-0", expanded);
    });
  });
};
